import { render, staticRenderFns } from "./AntiScam.vue?vue&type=template&id=ecd046f8"
import script from "./AntiScam.vue?vue&type=script&lang=js"
export * from "./AntiScam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports